import { Form } from 'antd';
import styled from 'styled-components';

export const CustomItem = styled(Form.Item)`
	.ant-form-item-explain-error {
		position: absolute;
		white-space: nowrap;
	}
`;
